import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'

import {StoppageCode} from '../types'

const QueryKey = 'plant-stoppages'
const INTERVAL_PERIOD_IN_MS = 300000

type Options<TSelect> = Omit<
  UseQueryOptions<StoppageCode[], AxiosError, TSelect>,
  'queryKey' | 'queryFn'
> & {
  onError?: (error: AxiosError) => void
}

export const usePlantStoppages = <TSelect = StoppageCode[]>(
  plantId: string,
  options?: Options<TSelect>
) => {
  const query = useQuery<StoppageCode[], AxiosError, TSelect>({
    queryKey: [QueryKey, plantId],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<StoppageCode[]>(
        `/plantconfig/${plantId}/stoppage-codes`,
        {signal}
      )

      return response.data
    },
    refetchInterval: INTERVAL_PERIOD_IN_MS,
    staleTime: Infinity,
    ...options
  })

  const onError = options?.onError
  useEffect(() => {
    if (query.error) {
      onError?.(query.error)
    }
  }, [query.error, onError])

  return query
}
